module.exports = __webpack_public_path__ + "static/media/nvent-logo.1f0df695.png";